import { getStarknet } from 'get-starknet-core';
import { useCallback } from 'react';
import { EWalletType } from '../web3Store.enums';
import { useRemoveWeb3Account } from './useRemoveWeb3Account';
import useWalletId from './useWalletId';

export default function useDisconnectWallet(type: EWalletType) {
	const [walletId] = useWalletId(type);
	const { removeWeb3Account } = useRemoveWeb3Account();

	const disconnectWallet = useCallback(() => {
		if (!walletId) return;

		try {
			if (type === EWalletType.starknet) {
				getStarknet().disconnect();
			}
		} catch (err) {
			console.error("Couldn't disconnect from wallet", err);
		}

		// remove the wallet from the list of connected wallets
		removeWeb3Account(walletId);
	}, [removeWeb3Account, type, walletId]);

	return { disconnectWallet };
}
